module.exports = __webpack_public_path__ + "assets/images/04_active_2f62ca33d91af6eb9cf64cad6cad8dd4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avatars/04_active.png
// module id = 120
// module chunks = 0